export default __webpack_public_path__ + "static/media/taxi.5fee17c3.svg";